export class Settings {
  constructor() {
    this.showLanguageOptions = false;
  }
}